<template>
  <div>
    <v-form ref="contactsForm">
      <v-container fluid class="pa-0 pl-2">
        <v-row>
          <v-col cols="12" sm="6" md="6" lg="6">
            <v-btn color="primary" class="mt-1" @click="addNewContact">{{ $t('message.common.addNew') }}</v-btn>
          </v-col>
          <v-col class="d-flex" cols="12" sm="6" lg="3" md="4">
            <v-select :items="activeTypes" dense v-model="activeOrInactive" outlined item-text="text" item-value="id" :label="$t('message.customer.activeOrInactive')" hide-details></v-select>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-progress-linear v-if="loadingContacts" indeterminate color="primary"></v-progress-linear>
    <template v-if="listOfContacts && listOfContacts.length > 0">
      <v-container fluid class="pa-2">
        <v-row>
          <v-col cols="6" lg="3" md="4" v-for="(contact) in listOfContacts" :key="contact.id" class="mt-1">
            <v-hover v-slot:default="{ hover }">
              <v-card class="mt-1 elevation-3 participants" :elevation="hover ? 14 : 5">
                <v-list-item class="pa-1">
                  <v-avatar color="primary">
                    <span class="mx-auto white--text">
                      <b>{{ setAvatarName(contact) }}</b>
                    </span>
                  </v-avatar>
                  <v-divider class="ma-0 ml-1" vertical></v-divider>
                  <v-list-item-content class="pa-1 ma-0">
                    <v-list-item-title class="subtitle-1">{{ contact.firstname || '' }} {{ contact.lastname || '' }}</v-list-item-title>
                    <v-list-item-subtitle>
                      {{ $t('message.customer.email') }}:
                      <a :href="`mailto:${contact.email}`">{{ contact.email }}</a>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>{{ $t('message.user.mobile') }}: {{ contact.mobilephone || contact.telephone }}</v-list-item-subtitle>
                    <v-list-item-subtitle>{{ $t('message.common.note') }}: {{ contact.note }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-divider class="ma-0 ml-1" vertical></v-divider>
                  <v-list-item-action class="pa-0 ma-0">
                    <v-btn icon color="success" @click="editContactHandler(contact.id)">
                      <v-icon>colorize</v-icon>
                    </v-btn>
                    <v-btn icon color="error" @click="deleteContactHandler(contact.id)">
                      <v-icon>delete_outline</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
        <div class="text-center">
          <v-pagination v-model="contactActivePage" :length="contactLength" circle></v-pagination>
        </div>
      </v-container>
    </template>
    <v-dialog v-model="contactDialog" width="800" persistent>
      <form-data :references.sync="contactReference" :model="contactModel" ref="contactReference"></form-data>
    </v-dialog>
  </div>
</template>
<script>
import FormTemplate from '@/components/FormTemplate'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      customerId: this.$route.params.crm_id,
      contactDialog: false,
      contactModel: {},
      contactLoading: false,
      activeOrInactive: 1,
      listOfContacts: [],
      loadingContacts: false,
      contactActivePage: 1,
      contactLength: 0
    }
  },
  components: {
    'form-data': FormTemplate
  },
  computed: {
    ...mapState(['FORM_TYPE']),
    activeTypes () {
      return [
        { text: this.$t('message.tickets.all'), id: 1 },
        { text: this.$t('message.customer.active'), id: 2 },
        { text: this.$t('message.customer.Inactive'), id: 3 }
      ]
    },
    contactReference () {
      return {
        title: this.contactModel.id ? this.$t('message.customer.updateContact') : this.$t('message.customer.addContact'),
        properties: [{
          model: 'firstname',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.user.firstName'),
          class: 'lg4 md4 sm6'
        }, {
          model: 'lastname',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.user.lastName'),
          class: 'lg3 md4 sm6'
        }, {
          model: 'email',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_emailValidation,
          label: this.$t('message.customer.email'),
          class: 'lg5 md4 sm6'
        }, {
          model: 'mobilephone',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: `${this.$t('message.customer.mobile')}`,
          class: 'lg3 md4 sm6'
        }, {
          model: 'telephone',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: `${this.$t('message.customer.telephone')}`,
          class: 'lg3 md4 sm6'
        }, {
          model: 'note',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.common.note'),
          class: 'lg4 md4 sm6'
        }, {
          model: 'isactive',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'lg2 sm6 pt-2',
          label: this.$t('message.common.isActive')
        }, {
          model: 'receive_certificate',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'lg4 sm6 pt-2',
          label: this.$t('message.customer.receiveCertificate')
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.contactModel.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: () => this.saveUpdateContactHandler(),
          loading: this.contactLoading,
          is_show: true
        }, {
          name: 'close',
          color: 'info',
          click: () => this.closeAddNewContact(),
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    }
  },
  mounted () {
    this.getAllContactsHandler()
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === 'contacts') {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.deleteSuccess') })
        this.$store.commit('hideDialog')
        this.getAllContactsHandler()
      }
    })
  },
  watch: {
    activeOrInactive () {
      this.contactActivePage = 1
      this.getAllContactsHandler()
    },
    contactActivePage (val, oldVal) {
      if (val !== oldVal) this.getAllContactsHandler()
    }
  },
  methods: {
    setAvatarName (obj) {
      let avatarString = ''
      avatarString += obj.firstname ? this.getFirstLetterUppercase(obj.firstname) : ''
      avatarString += obj.lastname ? this.getFirstLetterUppercase(obj.lastname) : avatarString
      return avatarString
    },
    getFirstLetterUppercase (text) {
      return text ? text.charAt(0).toUpperCase() : ''
    },
    addNewContact () {
      this.contactDialog = true
      this.contactModel = { isactive: true }
    },
    closeAddNewContact () {
      this.contactDialog = false
      this.contactModel.id = undefined
      this.$refs.contactReference.$refs.validateForm.reset()
    },
    getAllContactsHandler () {
      this.loadingContacts = true
      let pageVal = this.contactActivePage || 1
      let query = {
        'filter': `customer_id eq ${this.customerId}`,
        'skip': ((pageVal - 1) * 8),
        'limit': 8,
        'include_count': true,
        'order_by': {
          'field': 'firstname',
          'asc_or_desc': 'asc'
        }
      }
      if (this.activeOrInactive === 2) query.additionalfilters = [`isactive eq '1'`]
      else if (this.activeOrInactive === 3) query.additionalfilters = [`isactive eq '0'`]
      this.$_executeApi('post', `contacts/query`, query)
        .then((response) => {
          let { values, count } = response.data
          this.totalContactCount = count
          this.contactLength = Math.ceil(count / 8)
          this.listOfContacts = values
        })
        .finally(() => {
          this.loadingContacts = false
        })
    },
    editContactHandler (id) {
      this.$_executeApi('get', `contacts/${id}`)
        .then((response) => {
          this.contactModel = response.data
          this.contactDialog = true
        })
    },
    saveUpdateContactHandler () {
      if (this.$refs.contactReference.$refs.validateForm.validate()) {
        this.contactLoading = true
        let model = this.$formatter.cloneVariable(this.contactModel)
        model.customer_id = this.customerId
        this.$_saveUpdateHandler('contacts', model)
          .then((response) => {
            this.closeAddNewContact()
            this.getAllContactsHandler()
          })
          .finally(() => {
            this.contactLoading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    deleteContactHandler (id) {
      let ids = [id]
      let payload = { ids, url: `contacts/delete_multiple`, module: 'contacts' }
      this.$store.commit('showDeleteDialog', payload)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
  }
}
</script>
